var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongjinOH
 * @contact hjoh@detech.co.kr
 * @date 2023-04-20
 * @brief SEI 진단점검하기 컴포넌트
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { alertState, checkTypeState } from "../../../../../recoil/assessmentState";
import { reLoad, userInfoLoginState } from "../../../../../recoil/userState";
// utils
import dayjs from "dayjs";
import { langId } from "../../../../../recoil/langState";
import * as HTTPUTIL from "../../../../../utils/api/HttpUtil";
import * as CUTIL from "../../../../../utils/commUtils";
import * as CONST from "../../../../../utils/Const";
import { useTrans } from "../../../../../utils/langs/useTrans";
function CheckStep3(props) {
    const t = useTrans();
    // recoil
    const [check, setCheck] = useRecoilState(checkTypeState);
    const userInfo = useRecoilValue(userInfoLoginState);
    const [reload, setReload] = useRecoilState(reLoad);
    const [alert, setAlert] = useRecoilState(alertState);
    const langIds = useRecoilValue(langId);
    // porps
    const { handleOpenPop } = props;
    // useState
    const [instrumentItem, setInstrumentItem] = useState(null);
    const [instrumentAdd, setInstrumentAdd] = useState({
        testObject: "",
        name: "",
        manufacturer: "",
        serialNo: "",
    });
    const [instrumentEdit, setInstrumentEdit] = useState({
        instrumentId: 0,
        testObject: "",
        name: "",
        manufacturer: "",
        serialNo: "",
    });
    const [openCloseAdd, setOpenCloseAdd] = useState("");
    const [errorList, setErrorList] = useState([]);
    let appPath = `?assessmentId=${check.assessmentId}`;
    // 진단점검 API
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/assessment${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reload + langIds,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setInstrumentItem(data.body);
                setCheck(Object.assign(Object.assign({}, check), { instrument: data.body.instrument.length, countOpenClose: data.body.countOpenClose, chekVersionTypeInfo: {
                        checkVersionId: data.body.checkVersionId,
                        versionNo: check.chekVersionTypeInfo.versionNo,
                    } }));
            }
        }
    }, [data, langId]);
    useEffect(() => {
        // 계측기 등록
        handleOpenPop("pop-add-info", _jsx(CheckInstrumentAddPop, { instrumentAdd: instrumentAdd, setInstrumentAdd: setInstrumentAdd, errorList: errorList, setErrorList: setErrorList, onChangeTestObject: onChangeTestObject, onChangeName: onChangeName, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: t("라벨.계측기정보") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => ClosePop("pop-add-info") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        // 계측기 수정
        handleOpenPop("pop-edit-info", _jsx(ChechItemUpdatepop, { instrumentEdit: instrumentEdit, setInstrumentEdit: setInstrumentEdit, errorList: errorList, setErrorList: setErrorList, onChangeTestObjectEdit: onChangeTestObjectEdit, onChangeNameEdit: onChangeNameEdit, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: t("라벨.계측기정보") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => ClosePop("pop-add-info") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        // 계패횟수
        handleOpenPop("pop-add-num", _jsx(CheckOpenClosePop, { openCloseAdd: openCloseAdd, setOpenCloseAdd: setOpenCloseAdd, onChangeInput: onChangeInput, errorList: errorList, setErrorList: setErrorList, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: t("라벨.개폐횟수") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => ClosePop("pop-add-num") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
    }, [instrumentAdd, instrumentEdit, openCloseAdd, errorList]);
    // 처음 선택 시 POST API
    function ChekPost(items) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/assessment`,
                appQuery: {
                    itemId: items.itemId,
                    checkVersionId: items.checkVersionId,
                    langId: langIds,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setCheck(Object.assign(Object.assign({}, check), { nextStep: "checkList", assessmentId: data.body.assessmentId, chekTypeInfo: {
                            checkTypeId: check.chekTypeInfo.checkTypeId,
                            checkTypeName: data.body.checkType,
                        }, chekSubTypeInfo: {
                            checkSubTypeId: check.chekSubTypeInfo.checkSubTypeId,
                            checkSubName: data.body.checkSubType,
                        }, chekVersionTypeInfo: {
                            checkVersionId: check.chekVersionTypeInfo.checkVersionId,
                            versionNo: data.body.checkVersionNo,
                        }, assessmentInfo: {
                            isTempSave: data.body.isTempSave,
                            reportId: 0,
                        } }));
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    //예약 POST
    function ChekDilyPost(items) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/assessment`,
                appQuery: {
                    itemId: items.itemId,
                    checkVersionId: items.checkVersionId,
                    inspector: items.inspector,
                    langId: langIds,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    ChekPut(data.body);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    function ChekDilyPut(items) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/assessment/${check.assessmentId}`,
                appQuery: {
                    itemId: items.itemId,
                    checkVersionId: items.checkVersionId,
                    inspector: items.inspector,
                    isTempSave: true,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    ChekPut(data.body);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    // 점검 예약 수정 완료
    function ChekPut(item) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/schedule/${check.schdeulerId}`,
                appQuery: {
                    dueDate: dayjs(check.dueDate).format("YYYYMMDD").toString(),
                    checkVersionId: item.checkVersionId,
                    isOutSource: true,
                    completionDate: dayjs(new Date()).format("YYYYMMDD").toString(),
                    assessmentId: item.assessmentId,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    setCheck(Object.assign(Object.assign({}, check), { nextStep: "checkList", assessmentId: item.assessmentId, chekTypeInfo: {
                            checkTypeId: check.chekTypeInfo.checkTypeId,
                            checkTypeName: item.checkType,
                        }, chekSubTypeInfo: {
                            checkSubTypeId: check.chekSubTypeInfo.checkSubTypeId,
                            checkSubName: item.checkSubType,
                        }, chekVersionTypeInfo: {
                            checkVersionId: check.chekVersionTypeInfo.checkVersionId,
                            versionNo: item.checkVersionNo,
                        }, assessmentInfo: {
                            isTempSave: item.isTempSave,
                            reportId: item.reportId,
                        }, schdeulerId: data.body.scheduleId, period: data.body.period, dueDate: data.body.dueDate, inspector: check.inspector }));
                    setReload(false);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    // 다음 step
    function NextStep(e) {
        if (check.assessmentId > 0) {
            // assessmentId가 있는 경우
            if (check.schdeulerId > 0) {
                // 이어하기로 들어 올 경우
                let items = {
                    checkVersionId: check.chekVersionTypeInfo.checkVersionId,
                    assessmentId: check.assessmentId,
                    inspector: check.inspector,
                };
                ChekDilyPut(items);
            }
            else {
                setCheck(Object.assign(Object.assign({}, check), { nextStep: "checkList" }));
            }
        }
        else {
            if (check.schdeulerId > 0) {
                let items = {
                    itemId: check.itemInfo.id,
                    checkVersionId: check.chekVersionTypeInfo.checkVersionId,
                    inspector: check.inspector,
                };
                ChekDilyPost(items);
            }
            else {
                let items = {
                    itemId: check.itemInfo.id,
                    checkVersionId: check.chekVersionTypeInfo.checkVersionId,
                };
                ChekPost(items);
            }
        }
    }
    // 이전 step
    function PreviousStep(e) {
        setCheck(Object.assign(Object.assign({}, check), { nextStep: check.preStep, preStep: check.nextStep, assessmentId: -1, chekSubTypeInfo: {
                checkSubName: "",
                checkSubTypeId: -1,
            }, chekVersionTypeInfo: {
                checkVersionId: -1,
                versionNo: "",
            } }));
    }
    // 닫기 버튼
    function ClosePop(id) {
        if (id == "pop-add-info") {
            setInstrumentAdd({
                testObject: "",
                name: "",
                manufacturer: "",
                serialNo: "",
            });
        }
        else if (id == "pop-edit-info") {
            setInstrumentEdit(null);
        }
        else if (id == "pop-add-num" && check.countOpenClose <= 0) {
            setOpenCloseAdd("");
        }
        CUTIL.jsclose_Popup(id);
        setErrorList([]);
    }
    // 계측기 수정
    function ItemUpdatepop(e, item) {
        setInstrumentEdit({
            instrumentId: item.instrumentId,
            testObject: item.testObject,
            name: item.name,
            manufacturer: item.manufacturer,
            serialNo: item.serialNo,
        });
        CUTIL.jsopen_Popup(e);
    }
    // 개폐횟수 등록, 수정
    function OpenCloseInfo(e, num) {
        if (check.countOpenClose > 0)
            setOpenCloseAdd(num);
        CUTIL.jsopen_Popup(e);
    }
    function onChangeTestObject(e) {
        setErrorList(errorList.filter((err) => err.field !== "testObject"));
        setInstrumentAdd(Object.assign(Object.assign({}, instrumentAdd), { testObject: e.target.value }));
    }
    function onChangeName(e) {
        setErrorList(errorList.filter((err) => err.field !== "name"));
        setInstrumentAdd(Object.assign(Object.assign({}, instrumentAdd), { name: e.target.value }));
    }
    function onChangeTestObjectEdit(e) {
        setErrorList(errorList.filter((err) => err.field !== "testObject"));
        setInstrumentEdit(Object.assign(Object.assign({}, instrumentEdit), { testObject: e.target.value }));
    }
    function onChangeNameEdit(e) {
        setErrorList(errorList.filter((err) => err.field !== "name"));
        setInstrumentEdit(Object.assign(Object.assign({}, instrumentEdit), { name: e.target.value }));
    }
    function onChangeInput(e) {
        setErrorList(errorList.filter((err) => err.field !== "openClose"));
        let value = e.target.value;
        let numValue = value.replace(/[^0-9]/g, "");
        if (numValue == value) {
            setOpenCloseAdd(numValue);
        }
        else {
            setErrorList([{ field: "openClose", msg: t("라벨.숫자만입력") }]);
        }
    }
    return (_jsx(_Fragment, { children: _jsx("main", Object.assign({ className: "container" }, { children: _jsxs("section", Object.assign({ className: "content step3" }, { children: [_jsxs("div", Object.assign({ className: "top" }, { children: [_jsx("p", Object.assign({ style: { color: check.dueDate ? "#FFFFFF" : "" } }, { children: "Step 3" })), _jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.계측기정보/개폐횟수입력") }))] })), _jsxs("div", Object.assign({ className: "bottom" }, { children: [_jsxs("div", Object.assign({ className: "form-area" }, { children: [_jsx("button", Object.assign({ type: "button", className: "btn-back bg-white", disabled: check.disabled ? true : false, onClick: (e) => PreviousStep(e) }, { children: _jsx("span", { children: t("라벨.이전") }) })), _jsxs("div", Object.assign({ className: "info-add" }, { children: [_jsx("span", Object.assign({ className: "name" }, { children: t("라벨.계측기정보") })), _jsx("button", Object.assign({ type: "button", className: "btn btn-add js-open", "data-pop": "pop-add-info", onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uACC4\uCE21\uAE30 \uC815\uBCF4 \uCD94\uAC00" })) }))] })), _jsx("ul", Object.assign({ className: "info-add-list" }, { children: check.instrument > 0 &&
                                            instrumentItem &&
                                            instrumentItem.instrument.map((item, idx) => (_jsxs("li", { children: [_jsx("span", Object.assign({ className: "name" }, { children: item.testObject })), _jsx("button", Object.assign({ type: "button", className: "btn btn-more js-open", "data-pop": "pop-edit-info", onClick: (e) => ItemUpdatepop(e, item) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: t("라벨.수정") })) }))] }, "checklist_" + idx.toString()))) })), check.countOpenClose <= 0 ? (_jsxs("div", Object.assign({ className: "info-add" }, { children: [_jsx("span", Object.assign({ className: "name" }, { children: t("라벨.개폐횟수") })), _jsx("button", Object.assign({ type: "button", className: "btn btn-add js-open", "data-pop": "pop-add-num", onClick: (e) => OpenCloseInfo(e, 0) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uAC1C\uD3D0 \uD69F\uC218 \uCD94\uAC00" })) }))] }))) : (
                                    // {/*<!--개폐횟수 수정일때-->*/}
                                    _jsxs("div", Object.assign({ className: "info-add edit" }, { children: [_jsx("span", Object.assign({ className: "name" }, { children: t("라벨.개폐횟수") })), _jsxs("div", Object.assign({ className: "right" }, { children: [_jsxs("span", Object.assign({ className: "number" }, { children: [instrumentItem && instrumentItem.countOpenClose, _jsx("strong", { children: t("라벨.회") })] })), _jsx("button", Object.assign({ type: "button", className: "btn btn-edit js-open", "data-pop": "pop-add-num", onClick: (e) => OpenCloseInfo(e, instrumentItem.countOpenClose) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uAC1C\uD3D0 \uD69F\uC218 \uCD94\uAC00" })) }))] }))] })))] })), _jsx("button", Object.assign({ type: "button", onClick: (e) => NextStep(e) }, { children: _jsx("span", { children: t("라벨.점검시작하기") }) }))] }))] })) })) }));
}
export default CheckStep3;
function CheckInstrumentAddPop(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReload = useSetRecoilState(reLoad);
    const [check, setCheck] = useRecoilState(checkTypeState);
    const [alert, setAlert] = useRecoilState(alertState);
    const langIds = useRecoilValue(langId);
    // props
    const { instrumentAdd, setInstrumentAdd, errorList, setErrorList, onChangeTestObject, onChangeName } = props;
    // 처음 선택 시 POST API
    function instrumentAddPost(item) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/assessment`,
                appQuery: {
                    itemId: item.itemInfo.id,
                    checkVersionId: item.chekVersionTypeInfo.checkVersionId,
                    langId: langIds,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    instrumentAddFirst(data.body);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    function instrumentAddFirst(item) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/assessment/${item.assessmentId}/instrument`,
                appQuery: {
                    testObject: instrumentAdd.testObject,
                    name: instrumentAdd.name,
                    manufacturer: instrumentAdd.manufacturer,
                    serialNo: instrumentAdd.serialNo,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    setCheck(Object.assign(Object.assign({}, check), { assessmentId: item.assessmentId, chekTypeInfo: {
                            checkTypeId: -1,
                            checkTypeName: item.checkType,
                        }, chekSubTypeInfo: {
                            checkSubTypeId: -1,
                            checkSubName: item.checkSubType,
                        }, chekVersionTypeInfo: {
                            checkVersionId: item.checkVersionId,
                            versionNo: item.checkVersionNo,
                        }, assessmentInfo: {
                            isTempSave: item.isTempSave,
                            reportId: item.reportId,
                        } }));
                    PopClose("pop-add-info");
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-add-info", type: CONST.TYPE_INNRE, divTag: t("라벨.계측기가등록되었습니다") }));
                    CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-add-info");
                    setReload(false);
                }
                else {
                    // need error handle
                    if (data.errorList) {
                        setErrorList(data.errorList);
                    }
                    else {
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }
        });
    }
    function instrumentAddClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/assessment/${check.assessmentId}/instrument`,
                appQuery: {
                    testObject: instrumentAdd.testObject,
                    name: instrumentAdd.name,
                    manufacturer: instrumentAdd.manufacturer,
                    serialNo: instrumentAdd.serialNo,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    PopClose("pop-add-info");
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-add-info", type: CONST.TYPE_INNRE, divTag: t("라벨.계측기가등록되었습니다") }));
                    CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-add-info");
                    setReload(false);
                }
                else {
                    // need error handle
                    if (data.errorList) {
                        setErrorList(data.errorList);
                    }
                    else {
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }
        });
    }
    function PopClose(id) {
        CUTIL.jsclose_Popup(id);
        setInstrumentAdd({
            testObject: "",
            name: "",
            manufacturer: "",
            serialNo: "",
        });
        setErrorList([]);
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsxs("ul", Object.assign({ className: "form__input mt-0" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.시험명") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.ex절연내압시험"), value: instrumentAdd.testObject, onChange: (e) => onChangeTestObject(e), className: errorList.filter((err) => err.field === "testObject").length > 0 ? "input-error" : "" }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "testObject").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.계측기형명") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.텍스트입력"), value: instrumentAdd.name, onChange: (e) => onChangeName(e), className: errorList.filter((err) => err.field === "name").length > 0 ? "input-error" : "" }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "name").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.제조사") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", placeholder: t("라벨.텍스트입력"), value: instrumentAdd.manufacturer, onChange: (e) => setInstrumentAdd(Object.assign(Object.assign({}, instrumentAdd), { manufacturer: e.target.value })) }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.시리얼번호") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", placeholder: t("라벨.텍스트입력"), value: instrumentAdd.serialNo, onChange: (e) => setInstrumentAdd(Object.assign(Object.assign({}, instrumentAdd), { serialNo: e.target.value })) }) }))] })] })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => PopClose("pop-add-info") }, { children: _jsx("span", { children: t("라벨.취소") }) })), check.assessmentId <= 0 ? (_jsx("button", Object.assign({ type: "button", onClick: (e) => instrumentAddPost(check) }, { children: _jsx("span", { children: t("라벨.저장") }) }))) : (_jsx("button", Object.assign({ type: "button", onClick: (e) => instrumentAddClick(e) }, { children: _jsx("span", { children: t("라벨.저장") }) })))] }))] }));
}
function ChechItemUpdatepop(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReload = useSetRecoilState(reLoad);
    const [alert, setAlert] = useRecoilState(alertState);
    // props
    const { instrumentEdit, setInstrumentEdit, errorList, setErrorList, onChangeTestObjectEdit, onChangeNameEdit } = props;
    // 계측기 수정
    function instrumentEditClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/assessment/instrument/${instrumentEdit.instrumentId}`,
                appQuery: {
                    testObject: instrumentEdit.testObject,
                    name: instrumentEdit.name,
                    manufacturer: instrumentEdit.manufacturer,
                    serialNo: instrumentEdit.serialNo,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    CUTIL.jsclose_Popup("pop-edit-info");
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-edit-info", type: CONST.TYPE_INNRE, divTag: "계측기가 수정 되었습니다." }));
                    setErrorList([]);
                    CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-edit-info");
                    setReload(false);
                }
                else {
                    // need error handle
                    if (data.errorList) {
                        setErrorList(data.errorList);
                    }
                    else {
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }
        });
    }
    //계측기 삭제
    function instrumentDeleteClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/assessment/instrument/${instrumentEdit.instrumentId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    CUTIL.jsclose_Popup("pop-edit-info");
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-edit-info", type: CONST.TYPE_INNRE, divTag: data.body }));
                    setErrorList([]);
                    CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-edit-info");
                    setReload(false);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsxs("ul", Object.assign({ className: "form__input mt-0" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.시험명") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.ex절연내압시험"), value: instrumentEdit.testObject, className: errorList.filter((err) => err.field === "testObject").length > 0 ? "input-error" : "", onChange: (e) => onChangeTestObjectEdit(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "testObject").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.계측기형명") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.텍스트입력"), value: instrumentEdit.name, className: errorList.filter((err) => err.field === "name").length > 0 ? "input-error" : "", onChange: (e) => onChangeNameEdit(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "name").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.제조사") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", placeholder: t("라벨.텍스트입력"), value: instrumentEdit.manufacturer, onChange: (e) => setInstrumentEdit(Object.assign(Object.assign({}, instrumentEdit), { manufacturer: e.target.value })) }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.시리얼번호") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", placeholder: t("라벨.텍스트입력"), value: instrumentEdit.serialNo, onChange: (e) => setInstrumentEdit(Object.assign(Object.assign({}, instrumentEdit), { serialNo: e.target.value })) }) }))] })] })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray", onClick: (e) => instrumentDeleteClick(e) }, { children: _jsx("span", { children: t("라벨.삭제") }) })), _jsx("button", Object.assign({ type: "button", className: "", onClick: (e) => instrumentEditClick(e) }, { children: _jsx("span", { children: t("라벨.수정") }) }))] }))] }));
}
function CheckOpenClosePop(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [check, setCheck] = useRecoilState(checkTypeState);
    const setReload = useSetRecoilState(reLoad);
    const [alert, setAlert] = useRecoilState(alertState);
    const langIds = useRecoilValue(langId);
    // props
    const { openCloseAdd, setOpenCloseAdd, onChangeInput, errorList, setErrorList } = props;
    // 처음 선택 시 POST API
    function ChekPost(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!openCloseAdd) {
                setErrorList([{ field: "openClose", msg: t("라벨.필수항목을입력하지않으셨습니다") }]);
            }
            else {
                let data = null;
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "POST",
                    appPath: `/assessment`,
                    appQuery: {
                        itemId: check.itemInfo.id,
                        checkVersionId: check.chekVersionTypeInfo.checkVersionId,
                        countOpenClose: openCloseAdd,
                        langId: langIds,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        PopClose("pop-add-num");
                        setReload(true);
                        setCheck(Object.assign(Object.assign({}, check), { assessmentId: data.body.assessmentId, chekTypeInfo: {
                                checkTypeId: check.chekTypeInfo.checkTypeId,
                                checkTypeName: data.body.checkType,
                            }, chekSubTypeInfo: {
                                checkSubTypeId: check.chekSubTypeInfo.checkSubTypeId,
                                checkSubName: data.body.checkSubType,
                            }, chekVersionTypeInfo: {
                                checkVersionId: check.chekVersionTypeInfo.checkVersionId,
                                versionNo: data.body.checkVersionNo,
                            }, assessmentInfo: {
                                isTempSave: data.body.isTempSave,
                                reportId: data.body.reportId,
                            } }));
                        setReload(false);
                    }
                    else {
                        // need error handle
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }
        });
    }
    // 계측횟수 등록, 수정
    function openCloseClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!openCloseAdd) {
                setErrorList([{ field: "openClose", msg: t("라벨.필수항목을입력하지않으셨습니다") }]);
            }
            else {
                let data = null;
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "PUT",
                    appPath: `/assessment/${check.assessmentId}`,
                    appQuery: {
                        countOpenClose: openCloseAdd,
                        isTempSave: true,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        PopClose("pop-add-num");
                        setReload(true);
                        if (check.countOpenClose <= 0) {
                            setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-add-num", type: CONST.TYPE_INNRE, divTag: t("라벨.개폐횟수가등록되었습니다") }));
                        }
                        else {
                            setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-add-num", type: CONST.TYPE_INNRE, divTag: t("라벨.개폐횟수가수정되었습니다") }));
                            CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-add-num");
                            setReload(false);
                        }
                        setReload(false);
                    }
                    else {
                        // need error handle
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }
        });
    }
    function PopClose(id) {
        CUTIL.jsclose_Popup(id);
        if (check.countOpenClose <= 0)
            setOpenCloseAdd("");
        setErrorList([]);
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("ul", Object.assign({ className: "form__input mt-0" }, { children: _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.개폐횟수") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.횟수를입력하세요"), className: errorList.filter((err) => err.field === "openClose").length > 0 ? "input-error" : "", value: openCloseAdd, onChange: (e) => onChangeInput(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "openClose").map((err) => err.msg) }))] }))] }) })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => PopClose("pop-add-num") }, { children: _jsx("span", { children: t("라벨.취소") }) })), check.assessmentId < 0 ? (_jsx("button", Object.assign({ type: "button", onClick: (e) => ChekPost(e) }, { children: _jsx("span", { children: t("라벨.저장") }) }))) : check.countOpenClose <= 0 ? (_jsx("button", Object.assign({ type: "button", onClick: (e) => openCloseClick(e) }, { children: _jsx("span", { children: t("라벨.저장") }) }))) : (_jsx("button", Object.assign({ type: "button", onClick: (e) => openCloseClick(e) }, { children: _jsx("span", { children: t("라벨.수정") }) })))] }))] }));
}
